import React from 'react'

const PaginationNext = (props) => (
    <li className="page-item">
        <button className={`btn btn-sm pagelink btn-outline-${props.color}`} onClick={props.handlerClick}>{props.text}</button>
    </li>
)

export default PaginationNext